module.exports = __webpack_public_path__ + "img/06@2x.6956d3af.png";